import axios from 'axios';
import { REACT_APP_API_BASE_URL, REACT_APP_ENV } from './constant';

const axiosPublic = axios.create({
    baseURL: REACT_APP_API_BASE_URL,
    timeout: REACT_APP_ENV == 'DEV' ? 100000 : 5000, //ms
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    }
})

export default axiosPublic